import PropTypes from "prop-types"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import CameraIcon from "../../images/icons/camera-108.png"
import TradesIcon from "../../images/icons/trades-108.png"
import RemIcon from "../../images/icons/rem-108.png"
import CommunicationIcon from "../../images/icons/communication-108.png"
import { DamageCaseIdShape } from "./redux/shapes"

export default class DamageCaseNavigation extends Component {
  static propTypes = {
    caseId: DamageCaseIdShape.isRequired,
    className: PropTypes.string,
    currentPage: PropTypes.string,
  }

  render() {
    const { caseId, className, currentPage } = this.props
    return (
      <div className={`damage-case-navigation ${className}`}>
        <Link
          className={`item pictures ${currentPage === "pictures" ? "current-screen" : ""}`}
          to={`/case/${caseId}/pictures`}
        >
          <div className="inner">
            <img className="icon icon-camera" alt="CAM" src={CameraIcon} />
          </div>
        </Link>

        <Link
          className={`item trades ${currentPage === "trades" ? "current-screen" : ""}`}
          to={`/case/${caseId}/trades`}
        >
          <div className="inner">
            <img className="icon icon-trades" alt="BRA" src={TradesIcon} />
          </div>
        </Link>

        <Link
          className={`item remdata ${currentPage === "remdata" ? "current-screen" : ""}`}
          to={`/case/${caseId}/remdata`}
        >
          <div className="inner">
            <img className="icon icon-rem" alt="REM" src={RemIcon} />
          </div>
        </Link>

        <Link
          className={`item communications ${currentPage === "communications" ? "current-screen" : ""}`}
          to={`/case/${caseId}/communications`}
        >
          <div className="inner">
            <img className="icon icon-communication" alt="COM" src={CommunicationIcon} />
          </div>
        </Link>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/DamageCaseNavigation.js